import { render } from "./PrivacyAbstract.vue?vue&type=template&id=1d312e14&scoped=true"
const script = {}

import "./PrivacyAbstract.vue?vue&type=style&index=0&id=1d312e14&scoped=true&lang=css"

import exportComponent from "F:\\unilearn\\unilearn-web-vue3\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d312e14"]])

export default __exports__